/**
 * Get all the string values from a deeply nested object and return them in an array.
 * Do not use with an object that has circular reference.
 * @param {Object=} obj - source object
 * @returns {string[]} - all the string values of the object
 */
export const objectToStringArray = (obj: Object = {}) => {
    const result: string[] = [];

    for (const value of Object.values(obj)) {
        if (typeof value === 'string') {
            result.push(value);

            continue;
        }

        if (typeof value === 'object') {
            result.push(...objectToStringArray(value));
        }
    }

    return result;
};
